<template>
  <div>
    <!-- hiddenDiv used to set button color of rainforest component -->
    <div
      class="text-primary-600"
      ref="hiddenDiv"
    ></div>

    <div
      class="bg-red-100 border-2 border-red-200 text-red-700 rounded p-3 mb-3 mx-4"
      v-if="message"
    >
      {{ message }}
    </div>

    <form
      @submit.prevent="confirmMethod"
      action="#"
      class="px-4"
    >
      <div id="payment-method-element"></div>
    </form>
  </div>
</template>

<script>
//import Payments from '../../repository/PortalPayments'
import Proposal from "../../repository/Proposal"

import Errors from "../../../js/helpers/Errors"

export default {
  name: "PortalBillingProposalStripePaymentMethodForm",

  inheritAttrs: false,

  props: {
    intent: { required: true, type: Object },
    proposal: { required: true, type: Object },
  },

  beforeDestroy() {
    // Clean up event listeners when component is destroyed
    if (this.paymentElement) {
      this.paymentElement.off("change")
    }
  },

  data() {
    return {
      loading: false,
      message: null,
      paymentElement: null,
      isValid: false,
    }
  },

  mounted() {
    this.setupStripe()
  },

  computed: {
    //using hiddenDiv to grab the color off of it to pass as prop to rainforest component
    primaryColor() {
      if (!this.$refs.hiddenDiv) {
        return null
      } // Add a guard clause
      const computedStyle = window.getComputedStyle(this.$refs.hiddenDiv)
      return computedStyle.color
    },
  },

  methods: {
    setupStripe() {
      this.$emit("loaded")
      this.loading = true
      this.stripe = Stripe(this.intent.stripe_key, {
        stripeAccount: this.intent.provider_id,
      })
      this.stripeElements = this.stripe.elements({
        clientSecret: this.intent.client_secret,
        appearance: {
          variables: { colorPrimary: this.primaryColor },
        },
      })

      // Create and store the payment element
      this.paymentElement = this.stripeElements.create("payment")
      this.paymentElement.mount("#payment-method-element")

      //event listener for form validity changes - we use this to determine if the form is valid or not
      //if form is valid in proposal flow we can submit the form or if form is invalid we can skip submission if payment method is not required
      this.paymentElement.on("change", (event) => {
        this.$emit("payment-method-change", event.value.type)

        // If complete, emit valid event, otherwise emit invalid
        if (event.complete) {
          this.isValid = true
          this.$emit("valid")
        } else {
          this.isValid = false
          this.$emit("invalid")
        }

        if (event.error) {
          this.message = event.error.message
        } else {
          this.message = null
        }
      })

      this.loading = false
    },

    async confirmMethod() {
      this.message = null
      if (!this.stripe) {
        return
      }

      this.loading = true
      try {
        const { error } = await this.stripeElements.submit()

        if (error) {
          this.loading = false
          return
        }

        this.stripe
          .confirmSetup({
            elements: this.stripeElements,
            redirect: "if_required",
          })
          .then((result) => {
            if (result.error) {
              if (result.error.message) {
                this.message = result.error.message
              }

              this.loading = false

              return
            }

            this.$nextTick(() => this.saveMethod(result.setupIntent))
          })
      } catch (error) {
        this.$alert("Unable to process payment information. Please try again.")
        console.error(error)
        this.loading = false
      }
    },

    async saveMethod(setupIntent) {
      this.loading = true
      try {
        const { data } = await Proposal.savePaymentMethod(this.proposal, setupIntent)
        this.$emit("approve", data.data)
      } catch (e) {
        if (e.response?.status === 422) {
          this.$alert(new Errors(e.response.data).toArray().join(" "))
        } else {
          this.$alert("Unable to process payment information. Please try again.")
        }
        console.error(e)
      }
      this.loading = false
    },
  },
}
</script>

<style scoped></style>
